import Layout from "partials/layout";
import React, { useState, useEffect } from "react";
import styles from "./teachersprofessional.module.scss";
import { ERCButton } from "components/button";
import TeachersCourseCard from "components/teacherscoursecard";
import CounsellorChatCard from "components/counsellorchatcard";
import { PaginationSection } from "components/pagination/newPagination";
import { CourseServices } from "services/courses";
import { CardSkeleton } from "components/CardSkeleton";
// import ProfessionacounsellorCard from 'components/counsellorchatcard/professionalcounsellorcard'

const Teachersprofesional = () => {
  const [teacherCourses, setTeacherCourses] = useState([]);
  const [loading, setLoading] = useState(false);
  console.log("tc", teacherCourses);

  useEffect(() => {
    getAllTeachersCourse();
  }, []);

  const getAllTeachersCourse = async () => {
    setLoading(true);
    try {
      const response = await CourseServices.fetchTeacher();
      console.log("fetch Teachercourses", response);
      if (response.data.status === "success") {
        const res = response.data.data.details;
        setTeacherCourses(res?.rows);
        setLoading(false);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  // pagination section
  const [currentPage, setCurrentPage] = useState(1);
  const postsPerPage = 5;
  const lastPostIndex = currentPage * postsPerPage;
  const firstPostIndex = lastPostIndex - postsPerPage;
  const currentTableData = teacherCourses?.slice(firstPostIndex, lastPostIndex);
  // Calculate total pages
  const totalPosts = teacherCourses?.length;

  // Function to handle changing pages
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const courseCards = loading ? (
    <CardSkeleton />
  ) : (
    currentTableData.map((course, index) => (
      <TeachersCourseCard
        key={index}
        img={course.thumbnail}
        text={course.subCategory}
        lesson={course.duration}
        courseDescription={course.description}
        headerText={course.title}
        amount={course.amount}
      />
    ))
  );

  return (
    <Layout mqcolor="#00296b">
      <div>
        <div className={styles.professional_container}>
          <h1 className=" absolute md:top-[34%] top-[20%] leading-[50px] left-[10%] md:text-[50px] text-[46px] font-ManropeSemibold text-white">Professional Courses</h1>

          <div className="flex absolute top-[50%] left-[10%] md:text-[18px] text-[14px]  ">
            <h2 className="text-[#a3a3a3]">Home/Teacher's Centre/</h2>
            <h2 className="text-[#FFFFFF]">Professional/Courses</h2>
          </div>

          <div className=" w-full flex justify-center md:py-6 pb-12   px-6">
            {/* Search Input */}
            <input
              className="absolute top-[75%] md:w-[67%] w-[90%]  h-[75px] rounded-lg bg-[#fff] px-5 text-black placeholder-black focus:outline-none"
              placeholder="Search your favorite course"
            />

            {/* Search Button */}
            <div className="absolute top-[77.5%] md:right-[17%] right-[10%]">
              <ERCButton width="120px" size="18px">
                Search
              </ERCButton>
            </div>
          </div>

          <div className={styles.svg_container}>
            <div className={styles.svg1}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="213"
                height="317"
                viewBox="0 0 213 317"
                fill="none"
              >
                <path
                  d="M106.425 0C106.425 0 112.297 110.987 135.17 157.304C158.042 203.62 212.851 215.511 212.851 215.511C212.851 215.511 158.042 227.402 135.17 273.719C112.297 320.036 106.425 431.023 106.425 431.023C106.425 431.023 100.553 320.036 77.6808 273.719C54.8084 227.402 0 215.511 0 215.511C0 215.511 54.8084 203.62 77.6808 157.304C100.553 110.987 106.425 0 106.425 0Z"
                  fill="white"
                  fill-opacity="0.1"
                />
              </svg>
            </div>
            <div className={styles.svg2}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="163"
                height="278"
                viewBox="0 0 163 278"
                fill="none"
              >
                <path
                  d="M81.7548 0.664062C81.7548 0.664062 86.2323 71.915 103.673 101.649C121.113 131.383 162.904 139.017 162.904 139.017C162.904 139.017 121.113 146.651 103.673 176.385C86.2323 206.119 81.7548 277.37 81.7548 277.37C81.7548 277.37 77.2774 206.119 59.8371 176.385C42.3969 146.651 0.605469 139.017 0.605469 139.017C0.605469 139.017 42.3969 131.383 59.8371 101.649C77.2774 71.915 81.7548 0.664062 81.7548 0.664062Z"
                  fill="white"
                  fill-opacity="0.1"
                />
              </svg>
            </div>
            <div className={styles.svg3}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="214"
                height="326"
                viewBox="0 0 214 326"
                fill="none"
              >
                <path
                  d="M107.33 0.179688C107.33 0.179688 113.202 85.1327 136.074 120.585C158.947 156.037 213.755 165.139 213.755 165.139C213.755 165.139 158.947 174.241 136.074 209.693C113.202 245.145 107.33 330.098 107.33 330.098C107.33 330.098 101.458 245.145 78.5851 209.693C55.7127 174.241 0.904297 165.139 0.904297 165.139C0.904297 165.139 55.7127 156.037 78.5851 120.585C101.458 85.1327 107.33 0.179688 107.33 0.179688Z"
                  fill="white"
                  fill-opacity="0.25"
                />
              </svg>
            </div>
            <div className={styles.svg4}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="163"
                height="223"
                viewBox="0 0 163 223"
                fill="none"
              >
                <path
                  d="M81.2978 -208.525C81.2978 -208.525 85.7752 -97.5384 103.215 -51.2217C120.656 -4.90494 162.447 6.98596 162.447 6.98596C162.447 6.98596 120.656 18.8769 103.215 65.1936C85.7752 111.51 81.2978 222.497 81.2978 222.497C81.2978 222.497 76.8203 111.51 59.3801 65.1936C41.9398 18.8769 0.148438 6.98596 0.148438 6.98596C0.148438 6.98596 41.9398 -4.90494 59.3801 -51.2217C76.8203 -97.5384 81.2978 -208.525 81.2978 -208.525Z"
                  fill="white"
                  fill-opacity="0.1"
                />
              </svg>
            </div>
            <div className={styles.svg5}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="208"
                height="199"
                viewBox="0 0 208 199"
                fill="none"
              >
                <path
                  d="M106.574 0.890625C106.574 0.890625 112.446 85.8436 135.318 121.296C158.191 156.748 212.999 165.85 212.999 165.85C212.999 165.85 158.191 174.952 135.318 210.404C112.446 245.856 106.574 330.809 106.574 330.809C106.574 330.809 100.702 245.856 77.8293 210.404C54.9568 174.952 0.148438 165.85 0.148438 165.85C0.148438 165.85 54.9568 156.748 77.8293 121.296C100.702 85.8436 106.574 0.890625 106.574 0.890625Z"
                  fill="white"
                  fill-opacity="0.1"
                />
              </svg>
            </div>
          </div>
        </div>

        <div>
          {/* <div>
  <ERCText>Explore All Our <br></br>Professional <br></br>Courses</ERCText>
</div> */}

          {/* <ERCText >Categiories</ERCText>

<ERCText>View All</ERCText>

<div className='flex space-x-[12px]'>
  <input type='checkbox'/> <span><p>Tech</p></span>

  <div className='flex pb-[20px] relative bg-[#F8F8F8] w-[228px]'>
    <img className=" h-[100px]" src={"https://res.cloudinary.com/dmrtylvtc/image/upload/v1718285363/ERC/chick_vhg9ta.png"} alt="agile"/> 
    <div className=' pl-[15px]'>
    <ERCText lHeight='18px' color="#000" weight='600' size='12px' lSpacing='0.06px'>Agile and Scrum <br></br>Methodologies</ERCText> 
    </div>
    <div className='absolute left-[40%] top-[40%]'>
    <ERCText color='#00296B' weight='600' lHeight='18px' lSpacing='0.06px' size='12px'><br className="pt-[100%]"></br>Tech</ERCText>
    </div>
  </div>
  
</div> */}
        </div>

        <div className="lg:px-36 md:px-24 px-6 grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 py-12 ">
          {courseCards}
        </div>
        <div className="w-full md:px-24 px-6 pb-12 ">
          <PaginationSection
            totalPosts={totalPosts}
            postsPerPage={postsPerPage}
            currentPage={currentPage}
            setCurrentPage={handlePageChange}
          />
        </div>

        <section className={styles.chat}>
          <CounsellorChatCard />
        </section>
      </div>
    </Layout>
  );
};

export default Teachersprofesional;
